module.exports = __webpack_public_path__ + "static/media/greyEsahyogi.83fb4416.svg";